import React from 'react';
import About from './About';
import Research from './Research';
import Design from './Design';
import {HashRouter, Route, Routes} from 'react-router-dom';
import {ThemeProvider, createTheme} from '@mui/material/styles';
import './style/App.css';

const theme = createTheme({
  palette: {
    secondary: {
      main: '#000000',
    },
  },
});


/**
 *
 */
class App extends React.Component {
  state = {
    valid: true,
  };

  /**
   * @return {object} a <div> containing an different components to site
   */
  render() {
    return (
      <ThemeProvider theme={theme}>
        <HashRouter>
          <Routes>
            <Route path="/" element={<About/>}/>
            <Route path="/research" element={<Research/>}/>
            <Route path="/design" element={<Design/>}/>
          </Routes>
        </HashRouter>
      </ThemeProvider>
    );
  }
}

// // const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(<App />);

export default App;
